import React, { useEffect, useState } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import SummaryApi from '../common';

const AdminMinimumBar = () => {
    const [barMinimum, setBarMinimum] = useState('');
    const [number, setNumber] = useState(0);
    const [isChanged, setIsChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const handleInputChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setNumber(value >= 0 ? value : 0); 
        setIsChanged(value !== barMinimum?.at(0)?.seq); 
    };

    const saveChanges = async () => {
        setLoading(true);
        setMessage(null);
        try {
            const response = await fetch(SummaryApi.updateBarMinimum.url, {
                method: SummaryApi.updateBarMinimum.method,
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ number }) 
            });

            const responseData = await response.json();
    
            if (responseData.success) {
                setMessage({ type: 'success', text: 'تم التحديث بنجاح!' });
                setIsChanged(false);
                fetchBarMinimum();
            } else {
                setMessage({ type: 'error', text: 'فشل في التحديث. حاول مجدداً.' });
                setIsChanged(false);
                fetchBarMinimum();
            }
        } catch (error) {
            setMessage({ type: 'error', text: 'فشل في التحديث. حاول مجدداً.' });
            setIsChanged(false);
        }
        setLoading(false);
    };

    const fetchBarMinimum= async () => {
        try {
            const response = await fetch(SummaryApi.getBarMinimum.url, {
                method: SummaryApi.getBarMinimum.method,
                credentials: 'include',
                headers: {
                    "Content-Type": 'application/json'
                }
            });
            const responseData = await response.json();
            setBarMinimum(responseData?.data);
            setNumber(responseData?.data?.at(0)?.seq)
        } catch (error) {
        }
    };

    useEffect(() => {
        fetchBarMinimum();
    }, []);


    return (
        <div className="flex flex-col items-center p-4 border rounded shadow-lg max-w-xs mx-auto text-right">
            <h2 className="text-lg font-semibold mb-2 text-center">الحد الأدنى للطلب</h2>
            <div className="flex items-center justify-between w-full mb-4">
                <input 
                    type="number" 
                    value={number} 
                    onChange={handleInputChange} 
                    className="w-full text-center border p-2 rounded" 
                    min="0"
                    disabled={loading}
                />
            </div>
            <button 
                onClick={saveChanges} 
                disabled={!isChanged || loading} // Only enable if changed and not loading
                className={`px-4 py-2 w-full rounded ${!isChanged || loading ? 'bg-gray-300' : 'bg-blue-500 hover:bg-blue-600'} text-white`}
            >
                {loading ? 'جاري الحفظ...' : 'حفظ'}
            </button>
            {message && (
                <div className={`mt-4 p-2 rounded text-sm ${message.type === 'success' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                    {message.type === 'success' ? <FaCheck /> : <FaTimes />} {message.text}
                </div>
            )}
        </div>
    );
};

export default AdminMinimumBar;
